import { render, staticRenderFns } from "./Elections.vue?vue&type=template&id=18462ece&scoped=true"
import script from "./Elections.vue?vue&type=script&lang=js"
export * from "./Elections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18462ece",
  null
  
)

export default component.exports